import LinkComponent from '../../atoms/LinkComponent'
import ImageComponent from '../../atoms/ImageComponent'
import pinIcon from './../../../../../assets/Navbar/pinIcon.svg';
import { FC, ReactNode } from 'react';

type IProps = {
    children: ReactNode,
    to: string
}

const HomesForSaleMenuItem: FC<IProps> = ({ children, to }) => {
    return (
        <LinkComponent to={to} className="hover:bg-white">
            <div className="mx-[24px] my-[12px] text-[14px] font-medium text-[#1a1a1a] flex gap-[6px] items-center">
                <ImageComponent
                    source={pinIcon}
                    alt="pin"
                    width="18px"
                /><span className="translate-y-[-1px]"
                >{children}</span>
            </div>
        </LinkComponent>
    )
}

export default HomesForSaleMenuItem